import reviews from './reviews'

export default
{
    reviews
};
